var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E0FC4D40-8EAF-4F8F-9A48-685D479A87EB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-453.000000, -390.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462,390 C457.032,390 453,394.032 453,399 C453,403.968 457.032,408 462,408 C466.968,408 471,403.968 471,399 C471,394.032 466.968,390 462,390 Z M459.561,402.861 L456.33,399.63 C455.979,399.279 455.979,398.712 456.33,398.361 C456.681,398.01 457.248,398.01 457.599,398.361 L460.2,400.953 L466.392,394.761 C466.743,394.41 467.31,394.41 467.661,394.761 C468.012,395.112 468.012,395.679 467.661,396.03 L460.83,402.861 C460.488,403.212 459.912,403.212 459.561,402.861 Z",
    id: "check"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.de483bd73a2c7688c52bc7bd4c0ccba9.svg";
export { ForwardRef as ReactComponent };